// 规则的版本和实验开关:玩家存档(sbplayer.ts)和进度回执(sbcheckpoint.ts)共用一套,读回时照开局那时的规矩置开关重放。
// 这里不碰浏览器的东西,引擎线程(sbworker.ts)也能引。

/** 规则的版本:每加一批改了老规矩的新规则(都挂实验开关)加一。存档、回执记下开局时的版本,
 * 读回时这以后加的新规则都置上开关、照开局那时的规矩重放,城和原来逐字一样;玩家可以点「换成最新规则」从头按新规矩重放。
 * 为什么:原来升存档版本挡新规则,读档要么不让读、要么按新规矩重放成另一座城,玩家的指令对不上、房子钱都变样。 */
export const RULES = 39;
/** 新规则的开关是第几版规则加的。
 * 第 13 到 18 版是玩家模式那条线(player-v2)加的:231 官员层级(13);233 上级考评留不留(14);232 市长选举(15);
 * 234 市长的政策杆、235 选举第二版、236 考评照换人的代价(16);237 提拔玩家先问本人(17);238 市长照账挑政策杆的档、239 市长不随便走(18)。
 * 第 19 版是合成 integ3 时进来的、第 18 版的存档那时还没有的:213 大平层、214 投资公司按真实订单募资、218 年度税预算(integ2 的 Codex 三条线);
 * 219–222(hospital:医院按地方起名、看病按远近、容量按诊室、扩建和新盖一本账);
 * 240–244、246、248、249(econ3:开局价位、新店先买设备、城塌的根子、公家招工、工钱行情、写字楼行情折回住宅);
 * 250–252(stockfix:股价估值、挂单簿、一次一次地招股;招股另外还挂在 Params::ipo 上,默认不开)。
 * 第 20 版是 integ4 带进来的(第 19 版的档 city.enou.org 上已经有了,不能再往第 19 版里加):econ3 第五轮的 203、205、206(按揭)、207(国库留现钱)、
 * 227–229(医院按活请医生、按活算诊室、升级要地方);玩家模式的 223(没对手的市长也算票)、224(柜台)、225(开发商不替玩家拿地)。
 * 第 21 版是 perf-late 加的:141 大平层有几户租得起、买得起三十天重数一回(按地块错开),中间照上回数的用;置位照原来每天重数。
 * 第 22 版也是 perf-late 加的:142 旧改估值表里的大平层方案先按住满算上界,连这样都到不了一成利的不数户数、不进表;置位照原来都估。
 * 138 柜台(主店的一部分)的股份不单独买卖、不接手;置位照原来能买卖。
 * 140 报了名以后去世、搬走的市长候选人当不了市长;置位照原来能当选(死人进了市政府、天天领工钱)。
 * 第 23 版是 govecon 加的:254 持有税进年度预算、253 医保基金按报销定费率、247 公家的人买设备、
 * 226 学校按坐得下的分老师和盖新校(空了一年的关掉)、245 吃喝玩乐按收入安排一份、215 馆子分大众中档高档。
 * 第 24 版是 landval 加的(估值看成交,见 14 的七点一百二十二):143 一套房的估值看同楼、附近同类近来的成交,房价指数分片区配;
 * 144 按收益折的折现率跟基准利率走;146 按收益折看附近的空置;199 房租水平看新签的租约;
 * 201 和配偶住在配偶自己房里的不再买来自住、缺钱卖房先算一个月的结余;136 买来收租的出价也扣维修费;202 拿地发包时层数挑细;
 * 208 去世、搬走的市长候选人不再收捐款。
 * 第 25 版是 buildlabor 的一条:42 按天计酬的建筑工人按算账要价(不低于找活能指望挣的、放弃稳定工作来的按有活干的几成折、挂着没活的天天找活)。
 * buildlabor 的 1(一天一个班)、59(迁徙扣住的钱)这一版没合。
 * 第 26 版是 commerce 加的(第三个开关字,见 docs/商业系统升级.md):257 馆子中档高档按买主各自心里的倍数出价(钱多的心里值得多);
 * 263 玩家自己定价的房,写字楼、铺面租出去和一周让价那两处不替他动价(原来漏了:玩家的空住宅一周被往写字楼行情让一次,
 * 被 NPC 的店租去当铺面时价位也被拉)。256 留给零售多雇人(B0),这一版没上。
 * 第 27 版是 capmkt(资本市场,见 14 的七点一百二十三):264 股东要的回报跟利率走(利率五年均线加行当溢价、
 * 小公司多一截)、265 新开的公司按同行估、266 分红不超过能分的(净资产减投进来的本钱)、267 增发按估值和最近成交价里低的、认购先吃便宜卖单、
 * 268 看法不一(各人对各家的估值有偏差,人只看身边几家加随手看的)、269 投资公司做市、270 放几成闲钱在股票上按算账(认购也算)、
 * 271 股东想卖才挂卖单(要价照行情)。
 * 第 28 版是 capmkt 第二轮:272 股份买卖都走挂单簿(增发是公司在簿上挂的卖单、认购挂买单撮合;投资公司认进别家、玩家入股、按股数买、全买下一个股东的、甩卖也走簿子);
 * 273 买单看得见(投资公司持有的每家都挂双边、没有的看好的挂八家;散户没便宜卖单时看好的挂两家限价买单等着)。
 * 第 29 版是期房资产负债修正:279 在建工程按实际投入计成本,未交房的预收款列负债,财报、估值和授信共用这个口径。
 * 第 30 版已随第21版发布:276 新签工程合同按轮次保存实际材料到账/进场账单,终结才认定预支返还债;
 * 277 关门卖设备所得再补尚未移交原讨薪流程的工资(含已离职欠条),先欠先补;不处理法院已移交债。
 * 278 真实新欠薪另存余额,原移交/未立案不销债,判赔与成功实付、律师费分开;不改原讨薪决策。
 * 280 法院与关停欠薪实付衔接,避免同笔欠薪重复清偿。
 * 工程债仅记录及显式现金偿款;完整普通债清算/债权交易/资产与COGS桥仍未接。
 * 第31版已发布:281 设备真实处置、未售保管与后续实款清偿;旧档仍走原清零/核销路径。
 * 第32版已发布:282 买房谈话融资成功后才腾空/撤牌;283 居民卖房按清贷净到账、残债和持有/替代住房现金流判断,保留个体差异；285 等待让价；未挂牌心里价保持正式24，284原型未通过、不上线。
 * 第33版已发布:290 商品行情仅记真实成功交付；付款失败不冒缺货，高档预算失败不抬价；原始挂单意图量保留。
 * 第34版候选:291 加固钢筋与混凝土到齐才一起领，缺料不重复消耗已到材料。
 * 第35版候选:292 承台钢筋/混凝土、293 砌块/电线分别到齐才一起领；缺料不消耗先到批次。
 * 第36版:295 外地商务客(按卖给邻城的服务来人)和酒店(租房当客房、房晚撮合)、296 游客住酒店吃馆子出价撮合,不再按公式分钱给饭馆(见引擎 hotel.rs)。
 * 第37版:301 酒店有前台夜班的固定人手,想开的按自己开一家的盘算(开在哪、开多大、分得到几个客人),房价按客人出的几档挑,住满了在旁边加房(见引擎 hotel.rs)。
 * 第38版(承包市场):274 建筑公司实收的材料预支计当天经营收入;298 建筑公司按全部成本(自己做完的合同保本的倍数,老板的工夫和本钱摊到自己一年能接到的活上)和忙闲报价(见引擎 build.rs)。
 * 第39版:209 开发商拿地借土地贷(押地,卖楼先还);304 政府和私人的地都走公开竞价(谁都能随时申请或挂牌,截止前公开加价带封顶,封顶最高的按第二家封顶加一口拿到,见引擎 tender.rs);302 店留人和招人用同一本账(按毛利算,生意变薄会辞人)。
 * 不含未上线的材料债与开发成本规则，按正式上线次序登记。 */
export const RULE_SWITCHES: [number, number][] = [
  [231, 13], [233, 14], [232, 15], [234, 16], [235, 16], [236, 16], [237, 17], [238, 18], [239, 18],
  [213, 19], [214, 19], [218, 19], [219, 19], [220, 19], [221, 19], [222, 19],
  [240, 19], [241, 19], [242, 19], [243, 19], [244, 19], [246, 19], [248, 19], [249, 19], [250, 19], [251, 19], [252, 19],
  [203, 20], [205, 20], [206, 20], [207, 20], [223, 20], [224, 20], [225, 20], [227, 20], [228, 20], [229, 20],
  [141, 21], [138, 22], [140, 22], [142, 22],
  [215, 23], [226, 23], [245, 23], [247, 23], [253, 23], [254, 23],
  [136, 24], [143, 24], [144, 24], [146, 24], [199, 24], [201, 24], [202, 24], [208, 24],
  [42, 25],
  [257, 26], [263, 26],
  [264, 27], [265, 27], [266, 27], [267, 27], [268, 27], [269, 27], [270, 27], [271, 27],
  [272, 28], [273, 28],
  [279, 29],
  [276, 30], [277, 30], [278, 30], [280, 30],
  [281, 31],
  [282, 32], [283, 32], [285, 32],
  [290, 33],
  [291, 34],
  [292, 35], [293, 35],
  [295, 36], [296, 36],
  [301, 37],
  [274, 38], [298, 38],
  [209, 39], [302, 39], [304, 39],
];
/** 开关号只到 383(引擎三个 128 位的字:第 0–127、128–255、256–383 位);再大的引擎会悄悄绕回去读别的位,这里一律不收。
 * 老存档里记的号都在 0..255,意思不变,照旧读得回。 */
export const MAX_BIT = 383;
/** 照这一版规则重放要置上的开关:这一版以后加的新规则都照原来。 */
export const rulesBits = (rules: number) => RULE_SWITCHES.filter(([, r]) => r > rules).map(([b]) => b);
/** 记下的开关加上开局以后才加的新规则,去重排好。 */
export const mergeBits = (bits: readonly number[] | undefined, rules: number) => [...new Set([...(bits ?? []), ...rulesBits(rules)])].sort((a, b) => a - b);
/** 这些引擎版本没改老规矩(新规矩都挂开关):存档、回执直接读,照开局时的规则重放。 */
export const SAME_ENGINE = ['player-v12', 'player-v13'];
/** 一串开关号是不是都在 0..383、从小到大不重复。 */
export const validBits = (bits: unknown): bits is number[] => Array.isArray(bits) && bits.length <= MAX_BIT + 1
  && bits.every((b, i) => Number.isSafeInteger(b) && b >= 0 && b <= MAX_BIT && (i === 0 || b > bits[i - 1]));
